module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors/img_reservation-ee3e1832ae2e12a58d8cd245e6693553.png";